import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const medicalDisclaimer = lang === 'es' ? 'AVISO MÉDICO: Los resultados varían entre cada paciente. El Lipolaser es un procedimiento estético no quirúrgico y no es un tratamiento para la obesidad ni un sustituto de dieta y ejercicio. Toda candidatura es evaluada individualmente por el equipo médico. Las imágenes utilizadas representan casos reales con consentimiento expreso.' : 'MEDICAL DISCLAIMER: Individual results vary. Lipolaser is a non-surgical aesthetic procedure and is not a treatment for obesity nor a substitute for diet and exercise. All candidacy is evaluated individually by the medical team. Images depict actual patients shared with express consent.';
  return <footer className="bg-brand-dark text-brand-cream py-24 relative overflow-hidden" data-id="element-155" data-mp="13nbppc6f0ewz">
      <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" data-id="element-156" data-mp="yohaek7np8hm"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-157" data-mp="1ehtwjgx6wm4j">
        {/* Top: brand + tagline */}
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-158" data-mp="1ihum9xpqojqw">
          <a href="/" className="inline-flex flex-col items-center gap-2 mb-8" data-id="element-159" data-mp="1na49h5zgz5ph">
            <span className="text-3xl font-serif font-light text-brand-cream" data-id="element-160" data-mp="1s97dqo7ml7we">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.3em] uppercase text-brand-gold" data-id="element-161" data-mp="vk9iz5zvl9z8">
              Beverly Hills
            </span>
          </a>

          <p className="text-brand-cream/60 font-light italic font-serif mb-6" data-id="element-162" data-mp="14jw9gwr2gvdi">
            {t('footer.tagline')}
          </p>

          <div className="w-10 h-px bg-brand-gold/50 mx-auto" data-id="element-163" data-mp="19j97mdne1ove"></div>
        </div>

        {/* Middle: navigation + legal links */}
        <div className="max-w-3xl mx-auto mb-16" data-id="element-164" data-mp="2fyjk7gbkj1v0">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8" data-id="element-165" data-mp="2kxw884e6eez6">
            <a href="/#beneficios" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-166" data-mp="2kzz8ricyfqi5">
              {t('nav.benefits')}
            </a>
            <a href="/#proceso" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-167" data-mp="25758d4a4zjcn">
              {t('nav.process')}
            </a>
            <a href="/#doctor" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-168" data-mp="1ch6d2r5cmpzj">
              {t('nav.doctor')}
            </a>
            <a href="/#testimonios" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-169" data-mp="1hicav3dv93fx">
              {t('nav.testimonials')}
            </a>
            <a href="/#preguntas" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-170" data-mp="os3wznqd5575">
              {t('nav.faq')}
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3" data-id="element-171" data-mp="2qkf5kw823kna">
            <Link to="/privacy" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-172" data-mp="2vj8l0u6wllq3">
              {t('footer.links.privacy')}
            </Link>
            <span className="text-brand-gold/30 text-[10px]" data-id="element-173" data-mp="3a73faf0k7y5a">·</span>
            <Link to="/terms" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-174" data-mp="3a6tquvv5xz1p">
              {t('footer.links.terms')}
            </Link>
            <span className="text-brand-gold/30 text-[10px]" data-id="element-175" data-mp="22trw46ihsmym">·</span>
            <Link to="/disclaimer" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-176" data-mp="2j0o3rpcq381x">
              {lang === 'es' ? 'Aviso Médico' : 'Medical Disclaimer'}
            </Link>
          </div>
        </div>

        {/* Medical disclaimer block — visible & required */}
        <div className="max-w-4xl mx-auto pt-12 border-t border-brand-cream/10" data-id="element-177" data-mp="249ozurmu17oo">
          <p className="text-[10px] text-brand-cream/40 font-light leading-relaxed text-center mb-8 tracking-wide" data-id="element-178" data-mp="31yqxuik4nv6l">
            {medicalDisclaimer}
          </p>

          <p className="text-[10px] text-brand-cream/30 font-light leading-relaxed text-center max-w-2xl mx-auto mb-8 italic" data-id="element-179" data-mp="2s0kvjzuesn17">
            {lang === 'es' ? 'Lipo Laser · Dermaclinic Beverly Hills opera bajo las regulaciones del Estado de California y cumple con HIPAA en el manejo de información médica protegida.' : 'Lipo Laser · Dermaclinic Beverly Hills operates under California State regulations and complies with HIPAA in the handling of protected health information.'}
          </p>

          <p className="text-brand-cream/30 text-[10px] font-medium tracking-widest uppercase text-center" data-id="element-180" data-mp="3sac96xfdkt59">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}